import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useAccountAppContext } from '@/app/AccountAppContext'
import { AccountApiError } from '@/api'

export const usePasswordChange = (returnTo: string) => {
    const { t } = useTranslation()

    const queryClient = useQueryClient()

    const { api, accountKey, showSuccess, reauthenticate } = useAccountAppContext()

    return useMutation({
        mutationFn: (body: { newPassword: string }) => api.changePassword(body),
        retry: false,
        onError: (error) => {
            if (error instanceof AccountApiError && error.code === 'reauthenticationRequired') {
                reauthenticate(returnTo)
            }
        },
        onSuccess: async () => {
            showSuccess(t('messages.passwordUpdated'))
            await queryClient.invalidateQueries({ queryKey: ['account', accountKey, 'security'] })
        },
    })
}
